import * as React from "react";
import {Menu} from "@mui/material";
import {MenuItem} from "@mui/material";
import {Settings} from "@mui/icons-material";
import {Box, FormControlLabel, Switch} from "@mui/material";

export interface ITableSettings {
	densePadding: boolean
}

export interface IProps {
	settings: ITableSettings,
	onChangeSettings: React.Dispatch<React.SetStateAction<ITableSettings>>
}

export const AdminTableSettingsMenu: React.FC<IProps> = ({settings, onChangeSettings}) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = (): void => {
		setAnchorEl(null);
	};

	return (
		<div>
			<Box
				id="basic-button"
				onClick={handleClick}
				sx={{cursor: "pointer"}}
			>
				<Settings />
			</Box>
			<Menu
				id="admin-table-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button"
				}}
			>
				<MenuItem onClick={handleClose}>
					<FormControlLabel
						control={<Switch checked={settings.densePadding} onChange={(e) => onChangeSettings(prev => ({...prev, densePadding: e.target.checked}))} />}
						label="Dense padding"
					/>
				</MenuItem>
			</Menu>
		</div>
	);
}